const advisoriesList = [
    "Antonio Camargo",
    "Blanca Guerrero",
    "Derly Camargo",
    "Edwin Diaz",
    "July Chacon",
    "Elkin Camargo"
]
export default advisoriesList;